import React from "react";
import Hamza from "../../assets/about-us/hamza.jpeg";
import Uzair from "../../assets/about-us/uzair.jpeg";
import Khizar from "../../assets/about-us/khizar.jpeg";
import Saad from "../../assets/about-us/saad.jpeg";
import Osaid from "../../assets/about-us/osaid.jpeg";
import Shahzaib from "../../assets/about-us/shahzaib.jpeg";
import Imran from "../../assets/about-us/imran.jpeg";
import Danial from "../../assets/about-us/Danial.png";
import Areeba from "../../assets/about-us/areeba.png";
import Usman from "../../assets/about-us/usman.jpeg";

const teamMembers = [
  {
    id: 1,
    name: "Hamza Hanif",
    title: "Full Stack Developer (MERN & AI/RAG)",
    profile: Hamza,
  },
  {
    id: 2,
    name: " Muhammad uzair ",
    title: "Ai developer",
    profile: Uzair,
  },
  {
    id: 3,
    name: " Khizer Dawood ",
    title: "Ai developer",
    profile: Khizar,
  },
  {
    id: 4,
    name: " Saad Shakeel ",
    title: "Generative AI Developer",
    profile: Saad,
  },
  {
    id: 5,
    name: "  Muhammad Osaid Iqbal  ",
    title: "Flutter Developer",
    profile: Osaid,
  },
  {
    id: 6,
    name: "Shah Zaib ",
    title: "Flutter Developer",
    profile: Shahzaib,
  },
  {
    id: 7,
    name: " Usman Niaz ",
    title: "MEAN Stack Developer",
    profile: Usman,
  },
  {
    id: 8,
    name: " Areeba Khalid ",
    title: "MEAN Stack Developer",
    profile: Areeba,
  },
  {
    id: 9,
    name: "Imran Ali ",
    title: "MEAN Stack Developer",
    profile: Imran,
  },
  {
    id: 10,
    name: " Danial Gul  ",
    title: "Project manager TEKNEFY (Lead 3D designer)",
    profile: Danial,
  },
  {
    id: 12,
    name: "Rimsha Latif",
    title: "Graphic designer & UI/UX",
  },
];

const SupportingTeamsSection = () => {
  return (
    <section className="bg-white px-4 pb-12 pt-8 sm:px-6 sm:pb-16 sm:pt-10 lg:px-8 lg:pb-[68px] lg:pt-11">
      <div className="mx-auto max-w-[1728px]">
        <h2 className="text-center text-[28px] font-bold leading-tight text-black sm:text-[32px] sm:leading-[38px] lg:text-[40px] lg:leading-[47px]">
          Supporting Teams
        </h2>

        <div className="mt-10 grid grid-cols-1 gap-5 min-[480px]:grid-cols-2 sm:mt-12 lg:mt-[75px] lg:grid-cols-3 lg:gap-6 xl:grid-cols-5">
          {teamMembers.map((member) => (
            <article
              key={member.id}
              className="flex h-full flex-col overflow-hidden bg-white text-center shadow-[0_4px_4px_0_#00000040]"
            >
              <div className="flex w-full items-center justify-center bg-[#D9D9D9] px-3 py-4 sm:px-4 sm:py-5">
                {member.profile ? (
                  <img
                    src={member.profile}
                    alt={member.name}
                    className="max-h-44 w-full max-w-[240px] object-contain object-center sm:max-h-48 lg:max-h-[186px] lg:max-w-[269px]"
                  />
                ) : (
                  <div className="flex h-36 w-full max-w-[240px] items-center justify-center sm:h-40 lg:h-[186px] lg:max-w-[269px]">
                    <span className="text-sm text-[#6B7280]">Photo coming soon</span>
                  </div>
                )}
              </div>

              <div className="flex flex-1 flex-col px-3 pb-8 pt-8 sm:px-4 sm:pb-10 sm:pt-10 lg:pb-[50px] lg:pt-12">
                <h3 className="mb-1.5 text-base font-bold leading-snug text-black sm:text-lg sm:leading-[23px] lg:text-xl">
                  {member.name}
                </h3>

                <p className="text-sm leading-5 text-black sm:text-base sm:leading-[23px] lg:text-xl">
                  {member.title}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SupportingTeamsSection;
